import * as React from 'react';
const SvgIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M240-520h60v-80h-60zm100 80h60v-240h-60zm110 80h60v-400h-60zm110-80h60v-240h-60zm100-80h60v-80h-60zM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240zm126-240h594v-480H160v525zm-46 0v-480z"></path>
  </svg>;
export default SvgIcon;